<template>
  <!-- 災害検索 -->
  <div id="AppDisasterSearchResult">
    <!-- 上部余白 -->
    <div style="height: 10px" />

    <section>
      <div class="box" style="resultArea;" v-show="searched">
        <div class="columns">
          <div class="column is-two-thirds" style="text-align: left">
            <b-button
              v-if="
                positionCode == positionIdMap.gss ||
                positionCode == positionIdMap.branchMgr ||
                positionCode == positionIdMap.blockMgr ||
                positionCode == positionIdMap.gssMgr ||
                positionCode == positionIdMap.salesStrategy ||
                positionCode == positionIdMap.salesChief ||
                positionCode == positionIdMap.soc ||
                roleId == roleMap.systemManager
              "
              class="button is-primary has-text-centered"
              native-type="button"
              position="is-right"
              v-on:click="toDisasterEdit()"
            >
              災害追加
            </b-button>
            <b-button
              class="button is-primary has-text-centered"
              native-type="button"
              position="is-right"
              :disabled="!checkedRows.length"
              v-on:click="toSummary()"
            >
              サマリ
            </b-button>
            <b-button
              v-if="
                positionCode == positionIdMap.branchMgr ||
                positionCode == positionIdMap.blockMgr ||
                positionCode == positionIdMap.gssMgr ||
                positionCode == positionIdMap.salesChief ||
                positionCode == positionIdMap.soc ||
                roleId == roleMap.systemManager
              "
              class="button is-primary has-text-centered"
              native-type="button"
              position="is-right"
              :disabled="!checkedRows.length"
              v-on:click="showDisasterJoin()"
            >
              結合
            </b-button>
            <disaster-join-modal
              v-if="isShowDisasterJoin"
              v-model="isShowDisasterJoin"
              v-bind:disaster-list="checkedRows"
              @joined="joined"
            ></disaster-join-modal>
            <b-button
              class="button is-primary has-text-centered"
              native-type="button"
              position="is-right"
              :disabled="!checkedRows.length"
              v-on:click="downloadReport(reportList.hospital)"
            >
              医療機関向け報告書
            </b-button>
            <b-button
              class="button is-primary has-text-centered"
              native-type="button"
              position="is-right"
              :disabled="!checkedRows.length"
              v-on:click="downloadReport(reportList.hospitalSummary)"
            >
              医療機関向け報告書（サマリ）
            </b-button>
            <b-button
              v-if="
                positionCode == positionIdMap.salesStrategy ||
                positionCode == positionIdMap.salesChief ||
                positionCode == positionIdMap.soc ||
                roleId == roleMap.systemManager
              "
              class="button is-primary has-text-centered"
              native-type="button"
              position="is-right"
              :disabled="!checkedRows.length"
              v-on:click="downloadReport(reportList.mhlw)"
            >
              厚労省向け報告書
            </b-button>
            <b-button
              v-if="
                positionCode == positionIdMap.sales ||
                positionCode == positionIdMap.gss ||
                positionCode == positionIdMap.branchMgr ||
                positionCode == positionIdMap.blockMgr ||
                positionCode == positionIdMap.gssMgr ||
                positionCode == positionIdMap.salesChief ||
                positionCode == positionIdMap.soc ||
                roleId == roleMap.systemManager
              "
              class="button is-primary has-text-centered"
              native-type="button"
              position="is-right"
              v-on:click="showSelectPatient"
            >
              患者情報ダウンロード
            </b-button>
            <select-patient-form
              v-model="isShowSelectPatient"
              @selected="downloadPatients($event)"
            />
          </div>

          <div class="column">
            <b-field
              horizontal
              label="検索結果"
              style="float: right; white-space: nowrap"
            >
              <b-select position="is-right" v-model="perPage">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </b-select>
            </b-field>
          </div>
        </div>

        <!-- 結果一覧 -->
        <div>
          <b-table
            :data="data"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :pagination-position="paginationPosition"
            :pagination-size="paginationSize"
            :default-sort-direction="defaultSortDirection"
            default-sort="disasterId"
            checkable
            :checked-rows.sync="checkedRows"
            checkbox-position="left"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column
                field="disasterId"
                label="災害番号"
                sortable
                centered
              >
                {{ props.row.disasterId }}
              </b-table-column>
              <b-table-column
                field="entryDate"
                label="登録日"
                sortable
                centered
              >
                {{ props.row.entryDate }}
              </b-table-column>
              <b-table-column
                field="branchName"
                label="支店名"
                sortable
                centered
              >
                {{ props.row.branchName }}
              </b-table-column>
              <b-table-column
                field="disasterName"
                label="災害名"
                sortable
                centered
              >
                {{ props.row.disasterName }}
              </b-table-column>
              <b-table-column
                field="supportStatusSummary"
                label="対応状況"
                sortable
                centered
              >
                <div :style="getSupportStatusSummaryStyle(props.row)">
                  {{ props.row.supportStatusSummary | disasterSupportStatusSummaryFilter }}
                </div>
              </b-table-column>
              <b-table-column field="configuration" label="編集" centered>
                <b-button
                  class="button is-primary has-text-centered"
                  icon-left="checkbox-multiple-blank-outline"
                  native-type="button"
                  v-on:click="toDisasterEdit(props.row)"
                ></b-button>
              </b-table-column>
            </template>
          </b-table>
        </div>
      </div>
    </section>

    <!-- 下部余白 -->
    <div style="height: 10px" />
  </div>
</template>

<script>
import disasterJoinTemplate from "../components/common/DisasterJoin.vue";
import selectPatientTemplate from "../components/common/SelectPatient";
import {
  DISASTER_REPORT_TYPE,
  DISASTER_SUPPORT_STATUS_SUMMARY_MAP,
  DISASTER_CONTACT_STATUS_MAP,
} from "../utils/disaster";
import * as user from "../utils/user";

export default {
  props: {
    searchConditions: {
      type: Object,
      default: null,
    },
    data: {
      type: Array,
      default: [],
    },
    searched: {
      type: Boolean,
      default: false,
    }
  },

  components: {
    "disaster-join-modal": disasterJoinTemplate,
    "select-patient-form": selectPatientTemplate,
  },

  data() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let positionCode = userInfo.positionCode;
    let positionIdMap = user.POSITION_ID_MAP;
    let roleId = userInfo.roleId;
    let roleMap = user.ROLE_ID_MAP;

    return {
      userInfo,
      // ページ
      isPaginated: true,
      perPage: 10,
      currentPage: 1,
      perPage: 10,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      // ソート
      defaultSortDirection: "asc",
      // 選択
      checkedRows: [],
      // 災害結合
      isShowDisasterJoin: false,
      // 患者情報ダウンロード
      isShowSelectPatient: false,
      // 報告書印刷
      reportType: null,
      reportList: DISASTER_REPORT_TYPE,
      positionCode,
      positionIdMap,
      roleId,
      roleMap,
    };
  },

  computed: {},

  filters: {},

  methods: {
    downloadReport: function (reportType) {
      this.reportType = reportType;
      // 災害報告書印刷API実行
      this.downloadApiCall(this.getReportPOST, this.getReportPOSTError);
      return;
    },

    getReportPOST: function (client) {
      // パラメータ準備
      const disasterIdList = [];
      for (const row of this.checkedRows) {
        disasterIdList.push(row.disasterId);
      }

      // 災害報告書印刷API実行
      const apiRes = client.apis.apiDisaster.getReportPOST({
        body: {
          disasterIdList: disasterIdList,
          reportType: this.reportType,
        },
      });
      return apiRes;
    },

    getReportPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      return;
    },

    // 災害情報管理へ遷移
    toDisasterEdit: function (row) {
      let disasterId;
      if (row) {
        disasterId = row.disasterId;
      } else {
        disasterId = "";
      }
      this.$router.push({
        name: "AppDisasterEdit",
        params: {
          disasterId: disasterId,
          searchConditions: this.searchConditions,
        },
      });

      return;
    },

    // サマリへ遷移
    toSummary: function () {
      this.$router.push({
        name: "AppDisasterSummary",
        params: {
          disasters: this.checkedRows,
          searchConditions: this.searchConditions,
        },
      });

      return;
    },

    // 災害結合
    joined: function () {
      this.$emit("joined");
      return;
    },

    showDisasterJoin: function () {
      // 2つ以下の選択をはじく
      if (this.checkedRows.length < 2) {
        this.showErrorMessage("2つ以上の災害を選択してください");
        return;
      }

      // 異なる登録日・支店名をはじく
      let entryDate = this.checkedRows[0].entryDate;
      let branchName = this.checkedRows[0].branchName;
      for (let i = 1; i < this.checkedRows.length; ++i) {
        if ((entryDate != this.checkedRows[i].entryDate) ||
            (branchName != this.checkedRows[i].branchName)) {
          this.showErrorMessage("登録日、支店が同一の災害のみ結合が可能です");
          return;
        }
      }

      this.isShowDisasterJoin = true;
      return;
    },
    
    getSupportStatusSummaryStyle: function (row) {
      let _style;
      switch (row.supportStatusSummary) {
        case DISASTER_SUPPORT_STATUS_SUMMARY_MAP.progressing.code:
          _style = "background-color: #FFDD57; color: black; border-radius: 5px;";
          break;
        case DISASTER_SUPPORT_STATUS_SUMMARY_MAP.completed.code:
          _style = "background-color: #23D160; color: white; border-radius: 5px;";
          break;
      }

      return _style;
    },

    showSelectPatient: function () {
      this.isShowSelectPatient = true;
    },

    downloadPatients: async function (patients) {
      this.addTargetPatients = patients;

      // API呼び出し
      await this.downloadApiCall(
        this.setDisasterPatientSupportsPOST,
        this.setDisasterPatientSupportsPOSTerror
      );

      return;
    },

    setDisasterPatientSupportsPOST: function (client) {
      let apiRes;
      let body = {
        addMode: "",
        disasterId: this.disasterId,
        patientList: [],
      };

      // 患者追加
      body.isDownload = true;
      body.addMode = "patient";
      for (const patient of this.addTargetPatients) {
        let productDetails = [];

        for (const product of patient.productDetail) {
          productDetails.push({
            productName: product.productName,
            productCode: product.productCode,
            hospitalName: product.hospitalName,
            hospitalCode: product.hospitalCode,
            serialNumber: product.serialNumber,
          });
        }

        body.patientList.push({
          officeCode: patient.officeCode,
          officeName: patient.officeName,
          patientCode: patient.patientCode,
          patientName: patient.patientName,
          patientNameKana: patient.patientNameKana,
          phoneNumber: patient.patientPhone,
          emergencyLevel: patient.emergencyLevel,
          contactStatus: DISASTER_CONTACT_STATUS_MAP.noContact.code,
          supportStatus: null,
          supportStaffCode: patient.userId,
          supportStaffName: patient.staffName,
          oldContactStatus: null,
          oldSupportStatus: null,
          postCode: patient.postCode,
          address: patient.address,
          therapy: patient.therapy,
          productDetails: productDetails,
        });

        this.addTargetPatients = null;
      }
      apiRes = client.apis.apiDisaster.setDisasterPatientSupportsPOST({ body });

      return apiRes;
    },

    setDisasterPatientSupportsPOSTSuccess: function (result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      return;
    },

    setDisasterPatientSupportsPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      return;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AppDisasterSearchResult.vue